import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxCard from "src/components/card/SfxCard.vue"
import { SFX_CARD_CONDENSED_HEIGHT } from "src/util/constants/configurations"
import { computed } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxCardCondensed',
  props: {
  done: {
    type: Boolean,
  },

  problem: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const classes = computed(() => {
  let cssClass = ""

  if (props.done) {
    cssClass = "sfx-card-condensed__done"
  } else if (props.problem) {
    cssClass = "sfx-card-condensed__problem"
  }

  return cssClass
})

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxCard, _mergeProps({ clickable: "" }, _ctx.$attrs, {
    class: ["q-my-sm sfx-card-condensed", classes.value],
    height: _unref(SFX_CARD_CONDENSED_HEIGHT)
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class", "height"]))
}
}

})